import { render } from "./LandingDemo.vue?vue&type=template&id=24d93f6a"
import script from "./LandingDemo.vue?vue&type=script&lang=js"
export * from "./LandingDemo.vue?vue&type=script&lang=js"

import "./LandingDemo.vue?vue&type=style&index=0&id=24d93f6a&lang=css"

import exportComponent from "C:\\Users\\甘小星\\Desktop\\sakai-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__